export default __webpack_public_path__ + "static/media/1912.639b6460.png";